import "./input-select.css";

const InputSelect = ({
  data,
  register,
  name,
  error,
  placeholder,
  value,
  onChange,
  defaultValue = "",
}) => {
  const isControlled = value !== undefined;

  return (
    <div className="input-div">
      <select
        className="input-select"
        name={name}
        defaultValue={!isControlled ? defaultValue : undefined}
        value={isControlled ? value : undefined}
        onChange={isControlled ? onChange : undefined}
        {...(register ? register(name) : {})}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {data.map((item) => (
          <option key={item.key} value={item.key}>
            {item.title}
          </option>
        ))}
      </select>
      {error && <span className="fade-in">{error}</span>}
    </div>
  );
};

export default InputSelect;
